/**
 * @fileoverview gRPC-Web generated client stub for dimensionsClientPortal_thirdparty_endpoint
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v6.32.1
// source: thirdparty.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as thirdparty_pb from './thirdparty_pb'; // proto import: "thirdparty.proto"


export class ThirdPartyEndpointClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorAuthenticateClient = new grpcWeb.MethodDescriptor(
    '/dimensionsClientPortal_thirdparty_endpoint.ThirdPartyEndpoint/AuthenticateClient',
    grpcWeb.MethodType.UNARY,
    thirdparty_pb.AuthenticateClientRequest,
    thirdparty_pb.AuthenticateClientResponse,
    (request: thirdparty_pb.AuthenticateClientRequest) => {
      return request.serializeBinary();
    },
    thirdparty_pb.AuthenticateClientResponse.deserializeBinary
  );

  authenticateClient(
    request: thirdparty_pb.AuthenticateClientRequest,
    metadata?: grpcWeb.Metadata | null): Promise<thirdparty_pb.AuthenticateClientResponse>;

  authenticateClient(
    request: thirdparty_pb.AuthenticateClientRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: thirdparty_pb.AuthenticateClientResponse) => void): grpcWeb.ClientReadableStream<thirdparty_pb.AuthenticateClientResponse>;

  authenticateClient(
    request: thirdparty_pb.AuthenticateClientRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: thirdparty_pb.AuthenticateClientResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/dimensionsClientPortal_thirdparty_endpoint.ThirdPartyEndpoint/AuthenticateClient',
        request,
        metadata || {},
        this.methodDescriptorAuthenticateClient,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/dimensionsClientPortal_thirdparty_endpoint.ThirdPartyEndpoint/AuthenticateClient',
    request,
    metadata || {},
    this.methodDescriptorAuthenticateClient);
  }

  methodDescriptorRegisterClient = new grpcWeb.MethodDescriptor(
    '/dimensionsClientPortal_thirdparty_endpoint.ThirdPartyEndpoint/RegisterClient',
    grpcWeb.MethodType.UNARY,
    thirdparty_pb.RegisterClientRequest,
    thirdparty_pb.RegisterClientResponse,
    (request: thirdparty_pb.RegisterClientRequest) => {
      return request.serializeBinary();
    },
    thirdparty_pb.RegisterClientResponse.deserializeBinary
  );

  registerClient(
    request: thirdparty_pb.RegisterClientRequest,
    metadata?: grpcWeb.Metadata | null): Promise<thirdparty_pb.RegisterClientResponse>;

  registerClient(
    request: thirdparty_pb.RegisterClientRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: thirdparty_pb.RegisterClientResponse) => void): grpcWeb.ClientReadableStream<thirdparty_pb.RegisterClientResponse>;

  registerClient(
    request: thirdparty_pb.RegisterClientRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: thirdparty_pb.RegisterClientResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/dimensionsClientPortal_thirdparty_endpoint.ThirdPartyEndpoint/RegisterClient',
        request,
        metadata || {},
        this.methodDescriptorRegisterClient,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/dimensionsClientPortal_thirdparty_endpoint.ThirdPartyEndpoint/RegisterClient',
    request,
    metadata || {},
    this.methodDescriptorRegisterClient);
  }

}

